module.exports = __webpack_public_path__ + "img/Process-pana.e649f453.png";